import queryString from "query-string";
/**
 * @description Convert the value of search location to object based on window's location
 * @return An object that contains the value of search location
 * @returnType Record<string, string>
 */
export const windowSearchLocationToObject = () => {
  const params = new URLSearchParams(
    window.location.search
  ) as unknown as Array<Array<string>>;
  const obj: Record<string, string> = {};
  for (const [key, value] of params) {
    obj[key] = value;
  }
  return obj;
};

export const parseLocation = () => {
  return queryString.parse(window.location.search) as Record<string, string>;
};

export const convertNumberListParamToArrayNumber = (
  value?: string | null
): Array<number> => {
  if (!value) return [];
  return value.split(",").reduce((accumulator: Array<number>, currentValue) => {
    const numberValue = Number(currentValue);
    if (currentValue && typeof numberValue === "number") {
      return [...accumulator, numberValue];
    }
    return accumulator;
  }, []);
};
